module.exports = __webpack_public_path__ + "static/media/clusters.0a29ec11.svg";